export const FOOD_AGGREGATE_LOADING = 'FOOD_AGGREGATE_LOADING';
export const FOOD_AGGREGATE_END_LOADING = 'FOOD_AGGREGATE_END_LOADING';
export const FOOD_AGGREGATE_FETCH_ALL_SUCCESS = 'FOOD_AGGREGATE_FETCH_ALL_SUCCESS';
export const FOOD_AGGREGATE_FETCH_ALL_FAIL = 'FOOD_AGGREGATE_FETCH_ALL_FAIL';
